import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Grid, IconButton, MenuItem, Select, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import UpdateUser from "../../users/UpdateUser";
import ReviewList from "./ReviewList";
import Success from "components/Success";
import { usersApi, updateUsersApi } from "store/api";
import { useNavigate } from "react-router";
import moment from "moment";
import { latestPendingReviewApi } from "store/api";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function ReviewTab () {
  const navigate = useNavigate();
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [updateUser, setUpdateUser] = React.useState({});
  const [day, setDay] = React.useState(2);

  const handleChangeDayFilter = event => {
    setDay(event.target.value);
  };

  const handleClickOpenUpdate = data => {
    setUpdateUser(data);
    setOpenUpdate(true);
  };

  const handleCloseUpdate = () => {
    setOpenUpdate(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);

  const handleSubmitUpdate = async e => {
    e?.preventDefault();
    let apiData = {
      userId: updateUser.userId,
      accountStatus: updateUser.accountStatus,
    };
    const response = await updateUsersApi(apiData);
    if (response?.success) {
      setMsg("Update user status successfully");
      setSuccess(true);
      setOpen(true);
      FetchUsers();
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    handleCloseUpdate();
  };

  const handleChangeUpdateUser = e => {
    const { name, value } = e.target;
    setUpdateUser(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const [users, setUsers] = React.useState([]);

  // Fetch API results
  const FetchUsers = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          keyword: searchTerm,
        };
    try {
      const response = await latestPendingReviewApi();
      if (response?.success) {
        const daysAgo = moment().subtract(day, "days");
        let data = response?.data.filter(order => moment(order.registrationTime).isAfter(daysAgo));
        setUsers(data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleChangeUser = async e => {
    const { value } = e.target;
    if (debounceTimeout) clearTimeout(debounceTimeout);
    const newTimeout = setTimeout(() => {
      FetchUsers(value);
    }, 500);
    setDebounceTimeout(newTimeout);
  };

  React.useEffect(() => {
    FetchUsers();
  }, [day]);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "min-content",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5' onClick={() => navigate("/user-details")}>
          Review
        </Typography>
        <div style={{ display: "flex", gap: "20px" }}>
          {/* <TextField
            placeholder='Search here...'
            InputProps={{
              endAdornment: (
                <IconButton color='inherit'>
                  <Search />
                </IconButton>
              ),
            }}
            onChange={handleChangeUser}
            style={{ backgroundColor: "", borderRadius: "4px" }}
          /> */}
          {/* <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={day}
            //   label='Filter'
            style={{ minWidth: "120px" }}
            onChange={handleChangeDayFilter}
          >
            <MenuItem value={2}>Last two days</MenuItem>
            <MenuItem value={7}>Last one week</MenuItem>
            <MenuItem value={14}>Last two week</MenuItem>
          </Select> */}
        </div>
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All' {...a11yProps(0)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {users?.length == 0 && <div>No User found</div>}
            {users?.length > 0 && (
              <ReviewList users={users} active={0} handleClickOpenUpdate={handleClickOpenUpdate} FetchUsers={FetchUsers} />
            )}
          </Grid>
        </TabPanel>
      </Box>
      <UpdateUser
        open={openUpdate}
        handleClose={handleCloseUpdate}
        handleSubmit={handleSubmitUpdate}
        updateUserData={updateUser}
        handleChangeUpdateUser={handleChangeUpdateUser}
      />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}
